import React, {FC, HTMLAttributes} from "react"
import styled, {StyledComponentBase} from "styled-components"


interface TextInputProps extends HTMLAttributes<HTMLInputElement> {
  label?: string;
  name?: string;
  value?: string;
}

const StyledInput = styled.input`
  width: 100%;
  border: 0;
  border-bottom: 2px solid #3B5049;
  outline: none;
  height: 40px;
  background: none; 
`;

const StyledLabel = styled.label`
  color: #3B5049;
  font-size: inherit;
`;

const TextInput: FC<TextInputProps> = ({ label, ...props }) => {
  return (
    <>
      <StyledInput {...props} />
      {label && <StyledLabel>{label}</StyledLabel>}
    </>
  );
};

export default TextInput
